module.exports = __webpack_public_path__ + "static/home-banner2-f224199fa4f62886235dc8a9c12240ce.png";